import { SearchPreset } from '@retro-ui/api-contract';

import { Models } from '@f/components/shared/search-parameter-form';

export function calculateCreditConsumption(
  searchParams?: SearchPreset | null,
  targetsCount?: number | null,
  models?: Models
) {
  if (!searchParams || !targetsCount) {
    return null;
  }

  const { model, length } = searchParams;

  if (!model || !length) {
    return null;
  }

  const modelDefinition = models?.find(m => m.id === model);

  if (!modelDefinition) {
    return null;
  }

  const variant = modelDefinition.variants.find(v => v.length === length);

  if (!variant) {
    return null;
  }

  const { credits_per_target: creditsPerTarget } = variant;

  const creditsToConsume = creditsPerTarget * targetsCount;

  return creditsToConsume;
}
